import Vue from 'vue'
import Vuex from 'vuex'
import {customersCollection, generateBd, mainAuth, usersCollection} from '@/FirebaseConfig'
import {toSlug} from '@/Helper' 
Vue.use(Vuex)
export default {
    namespaced:true,
    state:{
      data:{
        name:'',
        apiKey: '',
        authDomain: '',
        databaseURL: '',
        projectId: '',
        storageBucket: '',
        color: '#000000',
        logoUrl: '',
        backgroundUrl: '',
      },
      db_activada: false,
      selectedKey:'',
      record:{},
      publicRecord: {}
    },
    mutations:{
      cleanSelectedKey:(state)=>{
        state.selectedKey=''
      },
      getAllItems(state, item) {
        Vue.set( state.record, item.id, {...item.data()} )
      },
      setPublicRecord(state, item) {
        Vue.set( state.publicRecord, item.id, {...item.data()} )
      },
      clean(state,key){
        Vue.delete(state.record,key)
      }
    },
    actions:{
        getAll:context=>{
          context.state.record = {}
          customersCollection.get().then(data=>data.docs.map( async item => {
            if( await compare(item)) context.commit('getAllItems', item)
            context.commit('setPublicRecord', item)
          }))
        },
        setCustomer: async (context, slug) => new Promise( async (resolve, reject) => {
          try{
            let data = await customersCollection.where('slug', '==', slug).get()
            data.docs.map( item => context.state.data = item.data())           
            resolve (true)
          } catch (error ){
            reject(error)
          }   
        }),
        getAllDocuments: context=>{
          generateBd(context.state.data).then( ()=>{
            context.dispatch('Warehouse/getAll', '', { root: true })
            context.dispatch('ProductType/getAll', '', { root: true })
            context.dispatch('Product/getAll', '', { root: true })
            context.dispatch('Clients/getAll', '', { root: true })
            context.dispatch('UserType/getAll', '', { root: true })
            context.dispatch('Suppliers/getAll', '', { root: true })
            context.dispatch('Privileges/getAll', '', { root: true })
            context.dispatch('Documents/getAll', '', { root: true })
            context.dispatch('Operations/getAll', '', { root: true })
            context.dispatch('Users/getAll', '', { root: true })
            context.dispatch('PaymentMethods/getAll','', {root: true})
            context.dispatch('DocumentTypes/getAll','', {root: true})
            context.dispatch('Sales/getAll','', {root: true})
            context.dispatch('Motivos_de_traslado/getAll','', {root: true})
            context.dispatch('Transportista/getAll','', {root: true})
            context.dispatch('Driver/getAll','', {root: true})
            context.dispatch('Partidas_Contables/getAll', '', {root: true})
            context.dispatch('Cotizaciones/getAll','', {root: true})
            context.dispatch('correo_remitente/getAll','', {root: true})
            context.dispatch('Credenciales/obtener_todo','', {root: true})
            context.dispatch('Movimientos_contables/getAll', '', {root: true})
            context.dispatch('Ordenes_de_compra/getAll','',{root:true})
            context.dispatch('Arreglos/obtener_todo','',{root:true})

            context.dispatch('Helpers/obtener_mensaje_de_dase_de_datos', '', {root: true})
            context.dispatch('Trabajadores/getAll','',{root: true})
            
            context.commit('Helpers/launchSnackbar', `Bienvenido al sistema de: ${context.state.data.name}`, { root: true })
            context.state.db_activada = true
          }).catch(error=>console.log(error))
        },
        add:context=>{
          if(context.state.selectedKey==''){
            customersCollection.add({...context.state.data, slug: toSlug(context.state.data.name)}).then(()=>{
            context.commit('Helpers/launchSnackbar', '¡Se ha registrado una nueva empresa correctamente!', { root: true })
            context.dispatch('clearForm')
          })
          }else{
            customersCollection.doc(context.state.selectedKey).update(context.state.data).then(()=>{
            context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })                  
            context.dispatch('clearForm')
          })
          }
        },
        clean:(context, key)=>{
          customersCollection.doc(key).delete().then(()=>{{
            context.commit('Helpers/launchSnackbar', 'Se ha eliminado con éxito', { root: true })                
            context.commit('clean',key)}})
        },
        get:(context, key)=>{
          customersCollection.doc(key).get().then(doc=>{
            context.state.data = doc.data()
            context.state.selectedKey = key
          })
        },
        clearForm: context => {
          context.state.data = {
            name:'',
            apiKey: '',
            authDomain: '',
            databaseURL: '',
            projectId: '',
            storageBucket: '',
            color: '#000000',
            logoUrl: '',
            backgroundUrl: ''
          },
          context.state.selectedKey = ''
        },
    },
    getters: {
        record: state => Object.keys(state.record).map(item => ({...state.record[item], key: item }) ),
        publicRecord: state => Object.keys(state.publicRecord).map(item => ({...state.publicRecord[item], key: item }) ),

    },

}

const compare = async (item) => {

  if(!mainAuth.currentUser) return 
 
  const currentUserEmail = mainAuth.currentUser.email

  const lookingForUser = await usersCollection.where('email', '==', currentUserEmail).get()
    
  const customerListOfUser = lookingForUser.docs[0].data().customer

  return (customerListOfUser.indexOf(item.data().slug)>-1 ) ? true : false

}